export { default as VerifyEmailMessage } from './verify-email-message';
